









































































































import tipoUtenteSelector from '@/components/selectors/TipoUtenteSelector.vue';
import Vue from 'vue';
import * as utenteApi from '../services/utente-api';
import { UtenteDetailViewModel } from '../types';
import validationRulesMixin from '../components/mixin/validation-rules-mixin';

export default Vue.extend({
    mixins: [validationRulesMixin],

    components: { tipoUtenteSelector },
    data(): UtenteDetailViewModel {
        return {
            item: null,
            isValid: false,
        };
    },
    computed: {
        isNew(): boolean {
            return this.item != null && this.item.id === 0;
        },
    },
    methods: {
        async loadData(id: number): Promise<void> {
            if (id > 0) {
                this.item = await utenteApi.getByKey(id);
            } else {
                this.item = {
                    id: 0,
                    version: 0,
                    username: '',
                    nome: '',
                    cognome: '',
                    tipoUtenteId: 1,
                    attivo: false,
                    isPasswordScaduta: false,
                    dataUltimoLogin: null,
                    displayName: this.$i18n.t('labels.nuovo').toString(),
                };
            }
        },
        close() {
            this.$router.push({ name: 'UtenteList' });
        },
        async save() {
            if (!this.item) {
                return;
            }
            let response = null;
            if (this.isNew) {
                response = await utenteApi.create({
                    username: this.item.username,
                    tipoUtenteId: this.item.tipoUtenteId,
                    nome: this.item.nome,
                    cognome: this.item.cognome,
                });
            } else {
                response = await utenteApi.update({
                    id: this.item.id,
                    version: this.item.version,
                    username: this.item.username,
                    tipoUtenteId: this.item.tipoUtenteId,
                    nome: this.item.nome,
                    cognome: this.item.cognome,
                    attivo: this.item.attivo,
                });
            }
            this.loadData(response.id);
        },
    },
    async mounted() {
        await this.loadData(parseInt(this.$route.params.id));
        setTimeout(() => {
            this.isValid = (this.$refs.form as HTMLFormElement).validate();
        });
    },
});
